<template>
  <div class="card card-custom card-stretch gutter-b" style="max-height: 50.75vh; padding: 0.5rem;">
    <div class="card-header border-0" style="padding: 1rem 1rem 0rem 1rem;">
      <h3 class="card-title font-weight-bolder text-dark">To do list</h3>
      <div class="card-toolbar">
        <span class="flaticon2-calendar-6 pr-2 pl-2 text-hover-primary"
          style="font-size: 22px; font-weight: 700; cursor: pointer;" @click="toDoListCreateModal()"></span>
      </div>
    </div>
    <div class="card-body pt-2" style="overflow: auto; padding: 1rem;">
      <div v-if="list.length > 0">
        <template v-for="(item, i) in list">
          <div class="d-flex align-items-center mb-5" :key="i"
            style="background-color: rgb(243,246,249); padding: 1rem; border-radius: 10px;">
            <div class="d-flex flex-column flex-grow-1"
              style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; padding-right: 0.5rem; width: 60%;">
              <div class="text-dark-75 font-weight-bold mb-4"
                style="font-size: 16px; font-weight: 600; overflow: hidden;">
                {{ item?.title }}
              </div>
              <div class="text-dark-75 font-weight-bold" style="overflow: hidden;">
                {{ item?.desc }}
              </div>
            </div>
            <div class="d-flex flex-column justify-content-end">
              <span class="d-flex text-dark-75 font-weight-bold justify-content-end mb-2">
                <b-button variant="light" size="sm" class="mr-2" @click="confirmDeleteToDoList(item?._id, 3, item?.title)">
                  <span class="flaticon2-trash pl-1 pr-1"></span>
                </b-button>
                <b-button variant="success" size="sm" class="mr-2" @click="updateToDoList(item?._id, 1, item?.title)">
                  <span class="flaticon2-check-mark pl-1 pr-1"></span>
                </b-button>
                <b-button variant="danger" size="sm" @click="updateToDoList(item?._id, 2, item?.title)">
                  <span class="flaticon2-cancel-music pl-1 pr-1"></span>
                </b-button>
              </span>
              <span class="d-flex text-dark-75 font-weight-bold justify-content-end">
                {{ item?.time }}
              </span>
            </div>
          </div>
        </template>
      </div>
      <div class="row" style="margin-top: 15%;" v-else>
        <div class="col-12 d-flex justify-content-center">
          <img src="../../../../public/media/error/no_data.png" width="150" height="100" >
        </div>
        <div class="col-12 d-flex justify-content-center">
          <span style="font-weight: 700; font-size: 1.275rem;">No data</span>
        </div>
      </div>
    </div>
    <b-modal id="toDoListCreateForm" ref="toDoListCreateModal" centered no-enforce-focus size="md" title="สร้างรายการ">

      <label class="mr-sm-2">หัวข้อ</label>
      <b-form-input v-model="toDoListCreateForm.title" type="text" size="sm"></b-form-input>

      <label class="mr-sm-2 mt-3">รายละเอียด</label>
      <b-form-input v-model="toDoListCreateForm.detail" type="text" size="sm"></b-form-input>

      <div class="d-flex">
        <div class="pr-1">
          <label class="mr-sm-2 mt-3">เวลาเริ่ม</label>
          <date-picker v-model="toDoListCreateForm.startToDo" type="datetime"></date-picker>
        </div>
        <div class="pl-1">
          <label class="mr-sm-2 mt-3">เวลาสิ้นสุด</label>
          <date-picker v-model="toDoListCreateForm.endToDo" type="datetime"></date-picker>
        </div>
      </div>

      <template #modal-footer="{ cancel }">
        <b-button variant="success" @click="confirmCreateToDoList()">
          สร้าง
        </b-button>
        <b-button variant="danger" @click="cancel()">
          ยกเลิก
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Dropdown2 from "@/view/content/dropdown/Dropdown2.vue";
import Dropdown4 from "@/view/content/dropdown/Dropdown4.vue";
import { mapGetters } from "vuex";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Swal from 'sweetalert2'
import FetchService from "@/core/services/fetch.service";
import moment from 'moment';
import no_data from '/public/media/error/no_data.png'

export default {
  name: "widget-4",
  data() {
    return {
      list: [
        {
          title: "Service : ใบหยกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกก",
          desc: "ทีม พี่เอฟหกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกกก",
          svg: "media/svg/icons/Home/Library.svg",
          style: "success",
          time: "ครบกำหนด 2024-01-21 14:00"
        },
        {
          title: "Install : PK แมนชั่น",
          desc: "ทีม พี่บี",
          svg: "media/svg/icons/Communication/Write.svg",
          style: "primary",
          time: "ครบกำหนด 2024-01-21 14:00"
        },
        {
          title: "Repair : PK แมนชั่น",
          desc: "ทีม พี่ซี",
          svg: "media/svg/icons/Communication/Group-chat.svg",
          style: "warning",
          time: "ครบกำหนด 2024-01-21 14:00"
        },
      ],
      toDoListCreateForm: {
        title: "",
        detail: "",
        startToDo: "",
        endToDo: "",
      },
      toDoListMasterData: [],
    };
  },
  components: {
    Dropdown2,
    Dropdown4,
    DatePicker,
    no_data
  },
  computed: {
    ...mapGetters(["layoutConfig"])
  },
  mounted() {
    this.getToDoList()
  },
  methods: {
    getToDoList() {
      FetchService.get("/get/todoList", res => {
        if (res) {
          res = JSON.parse(res)
          this.toDoListMasterData = res.todo_list
          this.pageInit()
        }
      })
    },
    pageInit() {
      const responseList = this.toDoListMasterData.map(e => {
        return {
          _id: e._id,
          title: e.title,
          desc: e.detail,
          time: e.end_date ? `ครบกำหนด ${moment(e.end_date).format("YYYY-MM-DD HH:mm")}` : ""
        }
      })
      this.list = responseList
    },
    clearForm() {
      this.toDoListCreateForm = {
        title: "",
        detail: "",
        startToDo: "",
        endToDo: "",
      }
    },
    toDoListCreateModal() {
      this.clearForm()
      this.$refs["toDoListCreateModal"].show();
    },
    confirmCreateToDoList() {
      if (this.toDoListCreateForm.title == "") {
        Swal.fire({
          title: 'กรุณากรอกข้อมูลให้ถูกต้อง',
          text: "กรุณากรอกข้อมูล-หัวข้อ",
          icon: 'error',
          confirmButtonColor: '#3699FE',
        })
      } else if (this.toDoListCreateForm.startToDo == "") {
        Swal.fire({
          title: 'กรุณากรอกข้อมูลให้ถูกต้อง',
          text: "กรุณากรอกข้อมูล-เวลาเริ่ม",
          icon: 'error',
          confirmButtonColor: '#3699FE',
        })
      } else if (this.toDoListCreateForm.endToDo == "") {
        Swal.fire({
          title: 'กรุณากรอกข้อมูลให้ถูกต้อง',
          text: "กรุณากรอกข้อมูล-เวลาสิ้นสุด",
          icon: 'error',
          confirmButtonColor: '#3699FE',
        })
      } else {
        Swal.fire({
          title: 'ยืนยันการบันทึก ?',
          text: "คุณยืนยันการบันทึก ใช่หรือไม่",
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3699FE',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ยืนยัน',
          cancelButtonText: 'ยกเลิก'
        }).then((result) => {
          if (result.isConfirmed) {
            this.addToDoList()
          }
        })
      }
    },
    addToDoList() {
      var raw = JSON.stringify({
        "title": this.toDoListCreateForm.title,
        "detail": this.toDoListCreateForm.detail,
        "start_date": this.toDoListCreateForm.startToDo,
        "end_date": this.toDoListCreateForm.endToDo,
      });

      let that = this
      FetchService.post("/add/todoList", raw, res => {

        Swal.fire(
          'สำเร็จ',
          'บันทึกข้อมูลแล้ว',
          'success'
        )
         
        that.getToDoList()
        this.$refs["toDoListCreateModal"].hide()
        this.$emit('task-added', []);
      })

    },
    updateToDoList(agToDoListId, agStatus, agTitle) {
      var raw = JSON.stringify({
        "title": agTitle,
        "status": agStatus,
      });


      let that = this
      FetchService.post(`/update/todoList/${agToDoListId}`, raw, res => {
        that.getToDoList()
        that.$emit('task-added', []);
      })
    },
    confirmDeleteToDoList(agToDoListId, agStatus, agTitle) {
      Swal.fire({
        title: 'ยืนยันการลบ ?',
        text: "คุณยืนยันการลบ ใช่หรือไม่",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3699FE',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          this.updateToDoList(agToDoListId, agStatus, agTitle)
          this.$emit('task-added', []);
        }
      })
    }

  }
};
</script>
